/**
 * Task-progress identifiers for Pre-Flight report generation. The BFF builds the
 * `TaskRecord` and the preflight worker patches its subtasks, so both sides must
 * agree on these ids — they live here rather than in either service.
 */
export const PREFLIGHT_REPORT_TASK_TYPE = 'generate-preflight-report';

export const PREFLIGHT_REPORT_STAGE_ID = 'analyze';

export const PREFLIGHT_REPORT_SUBTASK = {
    /** Report accepted and creatives fanned out for scoring. */
    PREPARE: 'prepare',
    /** One increment per creative reaching a terminal state. */
    SCORE: 'score',
    /** Report summary computed and persisted. */
    FINALIZE: 'finalize',
} as const;

/** Subtask metadata keys the card reads to render "3 of 8 creatives". */
export const PREFLIGHT_REPORT_COUNT_METADATA = {
    COMPLETED: 'completedCreatives',
    TOTAL: 'totalCreatives',
} as const;

/** `TaskNavigation.page` key resolving to the report detail route. */
export const PREFLIGHT_REPORT_NAVIGATION_PAGE = 'pre-flight-report';
